module.exports = __webpack_public_path__ + "img/ewh-3.d875365e.png";